var en = {
    accountCard: {
        availableToSpendText: 'Available to Spend',
        currentBalanceText: 'Current Balance',
        endingInText: 'Account ending in {{accountLast4}}',
        paymentDueDateText: 'Payment Due Date',
        totalMinimumPaymentText: 'Total Minimum Payment',
        viewPaymentOptionButton: 'View Payment Options'
    },
    questionnaireFooter: {
        nextQuestionButton: 'Next question',
        previousQuestionButton: 'Previous Question',
        previousStepButton: 'Previous step',
        submitQuestionnaireButton: 'Submit questionnaire',
        startButton: "Let's get started",
        backToPaymentOptions: 'Back to payment options',
        settlementReviewContinueButton: 'Accept Terms & Enroll',
        capReviewContinueButton: 'Accept Terms & Continue',
        continueButton: 'Continue',
        closeButton: 'Close',
        cancelButton: 'Back',
        enrollButton: 'Yes, Enroll',
        dontEnrollButton: "Don't Enroll",
        changePlanButton: 'Change Plan Selection'
    },
    paymentOptions: {
        heading: "We're here to help. Let's find a solution that works for you.",
        modalHeading: 'Payment Options',
        oneTimePaymentCardHeading: 'Make a One Time Payment',
        oneTimePaymentCardSubHeading: 'If you can pay your balance, your account could be up to date in one payment!',
        oneTimePaymentCardButton: 'Make a payment',
        settlementCardHeading: 'Settlement Plan',
        settlementCardSubHeading: 'Your account may be eligible for a settlement of much less than the balance due, if you can pay a portion in up to 3 installments. Start with a brief questionnaire.',
        settlementCardButton: 'Begin questionnaire',
        customerAssistanceCardHeading: 'Customer Assistance Plan',
        customerAssistanceCardSubHeading: 'Your account may be eligible for reduced monthly payments with no interest or fees. Start with a brief questionnaire. It should only take a few minutes to complete.',
        customerAssistanceCardButton: 'Begin questionnaire'
    },
    settlement: {
        startHeading: 'Help us better understand your situation',
        startSubheading: "Let's get started with a brief questionnaire – this should just take a few minutes.",
        startNoteText: "Note: Upon enrollment your account will be closed. You won't be able to make any future purchases.",
        optionsHeading: "You're eligible to enroll in a Settlement Plan",
        optionsSubHeading: 'Get part of your balance forgiven. Choose a payoff plan to continue.',
        cardDetailsDueByText: 'Due by',
        currentBalanceCardSubHeading: 'Current Balance',
        cardDetailsPaymentText: 'Payment',
        cardDetailsPaymentsText: 'Payments',
        cardDetailAmountText: 'Settlement Amount',
        reviewPlanHeading: 'Please review your selected Settlement Plan',
        reviewDisclosureHeading: 'If we fail to receive the above payments by the indicated dates, this settlement offer may be voided.',
        reviewDisclosureSubheading: 'Questions? Please call',
        reviewDisclosureText: 'If you have already paid the agreed upon settlement or paid through an alternate payment method, disregard payment options.',
        reviewCreditHeading: 'Update to your credit report',
        reviewCreditText: 'If you complete the settlement agreement, we will report the account to the major consumer reporting agencies as "Account paid in full for less than the full balance". This description may vary by consumer reporting agency, and it may take up to 60 days after the payment is received for this update to appear on your personal credit report.',
        disclosureBodyText: 'If we receive all payments by the due dates above, we will forgive the difference between these payments and your full balance and consider your account settled.',
        disclosureFooterText: 'We will make the following changes within 3 days after your account is enrolled in the settlement:',
        disclosureFooterFirstBulletText: 'Your account will be updated to no longer assess interest or penalty fees; your balances subject to interest will be $0.',
        disclosureFooterSecondBulletText: 'We will forgive any unpaid interest and fees at the end of the settlement, excluding any amount you agreed to pay as part of the settlement agreement.',
        disclosureFooterThirdBulletText: 'You will continue to receive monthly billing statements until the settlement agreement has been completed.',
        successHeading: 'Settlement Plan enrollment successful',
        successDetailsHeading: 'Settlement Plan Details',
        successSettlementAmountText: 'Settlement Amount',
        successPaymentDueDateText: '{{paymentCount}} Payment Due Date',
        successAmountDueText: 'Amount Due Monthly',
        planDisclosureText: 'This plan allows you to settle your account by paying just part of your balance in up to 3 installments.',
        contactHeading: 'You may be eligible for other payment plans',
        contactSubheadingPrefix: 'Please return to',
        contactSubheadingSuffix: 'to explore other plans',
        contactResourcesHeading: 'Additional Resources',
        contactResourcesText: 'You may also want to consider contacting the National Foundation of Credit Counseling (NFCC), the largest and longest serving network of nonprofit financial counselors. NFCC certified counselors offer services to help you manage your credit card debt with all of your creditors, provide one-on-one personalized financial counseling and may be able to reduce your monthly payments across creditors.',
        contactConnectTextPrefix: 'Connect now with NFCC',
        contactConnectTextSuffix: 'or call',
        questionnaireHeading: 'Questionnaire',
        reviewHeading: 'Review',
        enrollmentHeading: 'Enrollment'
    },
    plan: {
        forbearanceHeading: 'Based on your responses, your account may be eligible for a Customer Assistance Plan',
        forbearanceBodyText: 'This plan is designed to help pay down your debt by temporarily reducing your monthly payments and eliminating future interest and fees.',
        forbearanceContactText: 'Please call 877-350-4111 Monday-Friday 8am to 12am and Saturday-Sunday 8am to 6:30pm EST for more information.',
        reviewBannerHeading: "You're eligible to enroll in a Customer Assistance Plan",
        reviewBannerText: 'This plan is designed to help you pay off your debt by reducing your monthly payments and eliminating future interest and fees.',
        reviewPlanHeading: 'Please review your Customer Assistance Plan',
        reviewCardInfoText: 'Plan length is up to 60 months. There are no penalties for paying off early. Once you enroll and pay the rest of your payment plan,',
        reviewCardInfoBoldedText: "we'll reduce your APR to 0%.",
        fixedPaymentAmountLabel: 'Fixed payment amount',
        untilPaidInFullLabel: 'Until paid in full',
        reviewFooterText: "These changes may not bring your account up to date. We'll send you a confirmation letter with your enrollment details.",
        reviewCalculateHeading: 'How we calculate your monthly payments',
        reviewCalculateBullet1Text: '1.75% of the current balance',
        reviewCalculateBullet2Text: 'Plus 1.75% of deferred interest accrued from special financing (if applicable)',
        reviewCalculateBullet3Text: 'Plus any insurance or debt cancelation charges (if applicable)',
        confirmHeading: 'Are you sure you want to enroll in the Customer Assistance Plan?',
        confirmContinueButton: 'Yes, enroll',
        otherPaymentOptionsButton: 'Other payment options',
        successHeading: 'Customer Assistance Plan enrollment successful',
        successDetailsHeading: 'Customer Assistance Plan Details',
        totalAmountDueMonthlyLabel: 'Total Due Monthly',
        termLabel: 'Terms',
        termDetailsLabel: 'Until Paid in Full',
        enrollAutopayButton: 'Enroll in autopay',
        successSecondaryButton: 'Make a payment',
        messageBoxText: "Now that you're enrolled in a new plan, schedule automatic payments to avoid missing a due date.",
        messageBoxErrorText: 'Please call the number on the back of your card or statement to cancel or update it. Until then, your current autopay selection—not your reduced payment plan amount—will be debited.',
        messageBoxAutopayHeading: 'Enroll in Autopay and steer clear of missed payments!',
        messageBoxAutopayReEnrollHeading: 'Your Autopay was cancelled. Re-enroll in Autopay.',
        messageBoxCancelAutopayFailedHeading: 'We couldn’t cancel your autopay.',
        messageBoxAutopayEnrollLink: 'Enroll in Autopay'
    },
    common: {
        confirmEnrollBannerText: "Please note that enrolling will close your account. You won't be able to make any future purchases.",
        errorHeading: "We're having trouble accessing your account",
        errorText: 'Please try again later.',
        monthLabel: 'month',
        successSubHeading: 'A confirmation letter will be sent to the mailing address on your account.',
        leavingContactDisclosureText: 'Please note that because the site you are going to is not controlled by Synchrony, you will be subject to terms of use and privacy policy of the website you are visiting.',
        leavingContactHeading: 'Do you want to open the National Foundation of Credit Counseling (NFCC), website in a new tab?',
        openButton: 'Yes, open in a new tab',
        backButton: 'No, go back'
    }
};
export default en;
//# sourceMappingURL=en.js.map